export default __webpack_public_path__ + "static/media/dinero-en-efectivo.5e26f68a.svg";